import React from 'react';

export default function InviteFoil() {
  return (
    <div className="inv-foil">
      <i />
      <svg viewBox="0 0 24 24"><path d="M12 2l2.6 7.4L22 12l-7.4 2.6L12 22l-2.6-7.4L2 12l7.4-2.6z" fill="#C9A84C" /></svg>
      <i />
    </div>
  );
}